import axios from 'axios';
import { getCreatorApiUrl } from '../components/api-urls';
import auth from '../components/auth';
import * as Enums from '@playbook-technologies/common-enums';

const changeStatus = async (commentId: number, status: number) => {
  const endpoint = getCreatorApiUrl(`/moderation/comments/${commentId}/status`);

  const token = auth.getToken();

  await axios.patch(
    endpoint,
    {
      status,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
};

export const CommentApi = {
  keepComment: async (commentId: number) => {
    await changeStatus(commentId, Enums.Post.Status.Seen.value);
  },
  hideComment: async (commentId: number) => {
    await changeStatus(commentId, Enums.Post.Status.Archived.value);
  },
  changeCommentStatus: changeStatus,
};
